/**
 * Top-level terms of an Odoo domain list are implicitly ANDed, so two domain
 * strings combine by concatenating their inner terms.
 */
export const combineDomains = (...domains: (string | undefined)[]): string | undefined => {
  const inner = domains
    .filter((d): d is string => typeof d === 'string')
    .map(d => d.trim())
    .filter(d => d.startsWith('[') && d.endsWith(']'))
    .map(d => d.slice(1, -1).trim())
    .filter(d => d.length > 0);
  if (inner.length === 0) return domains.find(d => typeof d === 'string');
  return `[${inner.join(', ')}]`;
};
